import Activity, {
  ActivityMeta,
  implementsOfActivity,
} from '@/models/_deprecated/Activity';
import Lesson, { LessonMeta, implementsOfLesson } from '@/models/Lesson';
import React from 'react';
import { ExternalModalBankProps, UseFunctions } from '../ModalBank';
import { CreateActivityCard } from './CreateActivityCard';
import { CreateLessonCard } from './CreateLessonCard';
import { CreateQuestionCard } from './CreateQuestionCard';
import { useShouldShowItem } from '../ListBankCards.hooks';
import { bankTypes, enableQuery } from '@/utils/bank';

export type LessonWithMeta = Lesson & LessonMeta;
export type ActivityWithMeta = Activity & ActivityMeta;
export type Item = LessonWithMeta | ActivityWithMeta;

type CardsFactoryProps = {
  item: Item;
  mode: bankTypes;
  checkable?: boolean;
  disabledAnimation?: boolean;
  loading?: boolean;
} & UseFunctions &
  ExternalModalBankProps;

export default function CardsFactory({
  item,
  mode,
  onUseLesson,
  onUseActivity,
  onUseQuestion,
  ...rest
}: CardsFactoryProps) {
  const shouldShowBankItem = useShouldShowItem(item);

  if (!shouldShowBankItem) return <React.Fragment />;

  if (implementsOfActivity(item) && enableQuery(mode, 'questions')) {
    return <CreateQuestionCard item={item} onUse={onUseQuestion} {...rest} />;
  }
  if (implementsOfActivity(item) && enableQuery(mode, 'activities')) {
    return <CreateActivityCard item={item} onUse={onUseActivity} {...rest} />;
  }
  if (implementsOfLesson(item)) {
    return <CreateLessonCard item={item} onUse={onUseLesson} {...rest} />;
  }
  return <React.Fragment />;
}
